import RestClient from '../RestClient/RestClient';
import { getHostConfig } from './RestConfig';
import { STORES_URL, STORE_SERVICES_URL } from './CommonConstants';
import { apiHosts } from '../RestClient/FetchHelper.config';

export const fetchStores = (storeId) => {
    if (storeId) {
        const config = {
            url: `/${STORES_URL}/${storeId}`,
            version: '/v1',
            credentials: 'include',
            apiHost: apiHosts.browse,
        };

        return RestClient.get(config).catch(
            /* istanbul ignore next */
            // Ignoring this part in coverage as error can not be simulated
            (error) => {
                console.log(`request failed ${error}`);
            }
        );
    }
    return null;
};

/*
 * Function to fetch Store details by using lat long.
 * Sample API: https://browse-api.jcpenney.com/v1/stores?pageSize=1&latitude=33.0478852&longitude=-97.06059979999999&limit=5&page=1
 */
export const getStoresByLatLong = (params) => {
    let config = {
        url: STORES_URL,
        params,
        apiHost: apiHosts.browse,
        acceptVersion: '1',
        version: '/v1',
        credentials: 'include',
        XForwardedChannelHeaderHost: true,
    };
    config = getHostConfig(config);
    return RestClient.get(config).then((response) => response);
};

export const getFilterByServicePills = (params = {}) => {
    let config = {
        url: STORE_SERVICES_URL,
        params,
        apiHost: apiHosts.browse,
        acceptVersion: '1',
        version: '/v1',
        XForwardedChannelHeaderHost: true,
    };
    config = getHostConfig(config);
    return RestClient.get(config).then((response) => response);
};
